var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrive2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80764 18.6342L2.8628 20.4643C3.08204 20.8495 3.39764 21.1525 3.76838 21.3731L7.55325 18.6896L7.56014 14.8369L3.7831 13.1352L3.83795e-06 14.8234C-0.000746162 15.2495 0.108426 15.6758 0.327707 16.0611L1.80764 18.6342Z",
    fill: "#0066DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0137 7.14724L12.2112 2.12861L8.24536 0.597534C7.87383 0.816815 7.55714 1.11864 7.3365 1.50311L0.332109 13.5868C0.111516 13.9713 0.00075 14.3973 0 14.8233L7.56014 14.8368L12.0137 7.14724Z",
    fill: "#00AD3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0135 7.14725L15.6465 5.19284L15.8053 0.611043C15.4345 0.39045 15.0086 0.279731 14.5687 0.278934L9.48285 0.26984C9.04298 0.269043 8.61665 0.391997 8.24512 0.597543L12.0135 7.14725Z",
    fill: "#00831E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.44 14.8528L7.56027 14.8369L3.76855 21.3731C4.13929 21.5937 4.56524 21.7044 5.00507 21.7052L18.9707 21.7301C19.4106 21.7309 19.8369 21.608 20.2084 21.4024L20.2231 17.0121L16.44 14.8528Z",
    fill: "#0084FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2082 21.4025C20.5797 21.1832 20.8964 20.8814 21.117 20.4969L21.5583 19.7417L23.6679 16.1028C23.8885 15.7184 23.9992 15.2925 24 14.8663L19.6302 12.567L16.4536 14.8529L20.2082 21.4025Z",
    fill: "#FF4131"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1917 7.57423L16.7111 1.51985C16.4918 1.13454 16.1762 0.831586 15.8054 0.610992L12.0137 7.1472L16.4398 14.8527L23.9862 14.8662C23.9869 14.4401 23.8777 14.0138 23.6585 13.6285L20.1917 7.57423Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive2);
export default __webpack_public_path__ + "static/media/drive_2.879c95bf5384a06e273288df6ff9024e.svg";
export { ForwardRef as ReactComponent };